import { get } from './request'

export const getCategories = () => {
  return get('/api/v1/open/post/categories')
}

export const getPosts = (query) => {
  return get('/api/v1/posts', query)
}

export const getPostDetail = (id) => {
  return get('/api/v1/post', {
    id,
  })
}
